exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg[data-v-cf42b90e]{background:url(" + require("../../assets/bg_auth.jpg") + ");opacity:.5;position:absolute;top:0;right:0;bottom:0;left:0}.wrapper[data-v-cf42b90e]{display:flex;flex-direction:column;height:100vh;flex:1}.content[data-v-cf42b90e]{display:flex;flex-direction:row}.md-card[data-v-cf42b90e]{width:800px;padding:60px}.content[data-v-cf42b90e]:after,.content[data-v-cf42b90e]:before,.wrapper[data-v-cf42b90e]:after,.wrapper[data-v-cf42b90e]:before{content:\"\";flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-cf42b90e","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/views/NotFound.vue
// module id = 425
// module chunks = 0